import React, { useEffect, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { TextField } from '@mui/material';
import companylogo from "../../assets/company.png"

const AllReports = () => {
    const componentRef = React.createRef();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [data, setData] = useState([]);
    const [clientData, setclientData] = useState([]);


    useEffect(() => {
        const getClients = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
                if (res.ok) {
                    const data = await res.json();
                    const formattedData = data.client.map((client) => ({
                        id: client.id,
                        companyName: client.companyname
                    }));
                    setclientData(formattedData);
                } else {
                    console.error(`Error: ${res.status} - ${res.statusText}`);
                }
            } catch (error) {
                console.error(error);
            }
        };
        const fetchClientData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/accounts/all_accounts`);
                const responseData = await response.json();
                if (responseData) {
                    setData(responseData.client);
                }
            } catch (error) {
                console.log(error.message);
            }
        };
        fetchClientData();
        getClients();
    }, []);

    // const formatDate = (dateString) => {
    //     const dateObject = new Date(dateString);
    //     const day = ('0' + dateObject.getDate()).slice(-2);
    //     const month = dateObject.toLocaleString('default', { month: 'short' });
    //     const year = dateObject.getFullYear().toString().slice(-2);
    //     return `${day}-${month}-${year}`;
    // };

    const filteredData = data.filter((transaction) => {
        const transactionDate = new Date(transaction.date);
        return (
            (!startDate || transactionDate >= new Date(startDate)) &&
            (!endDate || transactionDate <= new Date(endDate))
        );
    });

    const clients = {};

    filteredData?.forEach((transaction) => {
        const { clientid, Balance, credit, debit, date, docid, description } = transaction;

        if (!clients[clientid]) {
            clients[clientid] = {
                clientid,
                totalDebit: 0,
                totalCredit: 0,
                closingBalance: parseFloat(Balance),
            };
        }

        clients[clientid].totalDebit += parseFloat(debit);
        clients[clientid].totalCredit += parseFloat(credit);
        clients[clientid].closingBalance = clients[clientid].totalCredit - clients[clientid].totalDebit;
    });

    const allClients = Object.values(clients);

    const totaldebit = allClients.reduce((sum, client) => sum + client.totalDebit, 0)
    const totalcredit = allClients.reduce((sum, client) => sum + client.totalCredit, 0)
    const totalbalance = totaldebit - totalcredit

    return (
        <div className='w-full'>
            <div className='mb-5 flex flex-row justify-center items-center gap-2'>
                <TextField
                    type='date'
                    value={startDate || ''}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                <TextField
                    type='date'
                    value={endDate || ''}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </div>
            <div className="invoice__preview w-full bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />
                <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                        <div>

                            <img  src={companylogo} alt="logo" />
                        </div>
                    </div>
                    <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                        <p>Statements of Accounts (Period)</p>
                    </article>
                    <table width="100%" className="mb-10">
                        <thead>
                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                <td className="font-bold">Client ID</td>
                                <td className="font-bold">Narration</td>
                                <td className="font-bold">Debit</td>
                                <td className="font-bold">Credit</td>
                                <td className="font-bold">Balance</td>
                            </tr>
                        </thead>
                        <tbody>
                            {allClients.map((client, index) => {
                                const matchingClientData = clientData.find(data => data.id === parseInt(client.clientid));

                                return (
                                    <tr key={client.clientid}>
                                        <td>{client.clientid}</td>
                                        <td>
                                            {matchingClientData
                                                ? matchingClientData.companyName
                                                : 'Company Name Not Found'}
                                        </td>
                                        <td>{client.totalCredit.toLocaleString()}</td>
                                        <td>{client.totalDebit.toLocaleString()}</td>
                                        <td>{(client.closingBalance * 1).toLocaleString()}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total Debit:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totalcredit}
                        </td>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total Credit:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totaldebit}
                        </td>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total balance:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totalbalance*-1}
                        </td>
                    </tr>
                    <tr className=" text-center h-10 font-bold mt-2">
                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                            Accountant
                        </td>
                    </tr>
                </div>
            </div>
        </div>
    );
};

export default AllReports;
